import { Button, Divider, Tooltip } from '@sede-enterprise/shell-ds-react-framework'
import { Filter } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import React, { useState } from 'react'
import AlertsPieChart from './AlertsPieChart';
import CorrosionAlertsTable from './CorrosionAlertsTable';
import RemnantAlertsTable from './RemnantAlertsTable';
import AlertsFilterModal from './filter/AlertsFilterModal';
import WtAlertsTable from './WtAlertsTable';

const AlertsListsScreen = () => {

    // Filter Modal
    const [open, setOpen] = useState(false);
    const handleFilterModalClose = () => {
        setOpen(false);
    }

    // Settting the filter for the analysis data
    const [alertsFilter, setAlertsFilter] = useState(sessionStorage.getItem("alertApplyfilter") || `sensor.excludeFromUi = 0`);
    console.log("Current Alerts Filter:", alertsFilter);
    //Selected Pie Filter
    const [filterType, setFilterType] = useState(null)


    const setPieFilterType = (pieType) => {
        setFilterType(pieType)
    }

    // Handling the sensor filter change
    const handleSensorFilterChange = (appliedFilter, filterFormValues) => {
        if (appliedFilter) {
            sessionStorage.setItem('alertApplyfilter', appliedFilter);
            sessionStorage.setItem('alertFilterValues', JSON.stringify(filterFormValues));
        } else {
            sessionStorage.removeItem('alertApplyfilter');
            sessionStorage.removeItem('alertFilterValues');
        }
        setAlertsFilter(appliedFilter);
    }

    //Clearing the sensor filter
    const clearSensorFilter = () => {
        sessionStorage.removeItem('alertApplyfilter');
        sessionStorage.removeItem('alertFilterValues');
        setAlertsFilter(`sensor.excludeFromUi = 0`);
    }


    const applyPieFilters = (selectedPie) => {
        const filtered_Data = sessionStorage.getItem('alertApplyfilter');
        let pieFilter;
        // If selectedPie is either "Measured Corrosion Rate" or "Predicted Corrosion Rate", set filterType to "corrosion"
        if (selectedPie === "Measured Corrosion Rate" || selectedPie === "Predicted Corrosion Rate") {
            pieFilter = filtered_Data ? `${filtered_Data} AND category IN ('${selectedPie}')` : `category IN ('${selectedPie}')`;
        } else {
            pieFilter = filtered_Data ? `${filtered_Data} AND eventCode = '${selectedPie}'` : `eventCode = '${selectedPie}'`;
        }
        
        setAlertsFilter(pieFilter)
    }


    const clearPieFilters = () => {
        const filtered_Data = sessionStorage.getItem('alertApplyfilter');
        setAlertsFilter(filtered_Data || `sensor.excludeFromUi = 0`)
    }

    return (
        <div className='parent-container'>
            <div className='content-container'>
                <div className='content-header'>
                    <h2>Alerts</h2>
                    <Tooltip overlay={<span>Filter Options</span>}
                        placement='bottom'
                        trigger={<Button iconOnly icon={<Filter />} data-testid="filter-btn"
                            variant='filled' onClick={() => setOpen(true)} />} />
                </div>
                <div className='content-body'>
                    <AlertsPieChart filters={alertsFilter} applyPieFilters={applyPieFilters} clearPieFilters={clearPieFilters} filterType={filterType} setPieFilterType={setPieFilterType} />
                    <br />
                    <br />
                    <Divider />
                    {(filterType === "corrosion" || filterType === null) && <CorrosionAlertsTable filter={alertsFilter} />}
                    <br />
                    <Divider />
                    {(filterType === "remnant" || filterType === null) && <WtAlertsTable filter={alertsFilter} />}
                    <br />
                    {(filterType === "remnant" || filterType === null) && <RemnantAlertsTable filter={alertsFilter} />}

                </div>
            </div>
            <AlertsFilterModal open={open} onClose={handleFilterModalClose}
                handleFilterChange={handleSensorFilterChange}
                handleFilterClear={clearSensorFilter} />
        </div>
    )
}

export default AlertsListsScreen